import React from 'react';
import PropTypes from 'prop-types';
import classes from './PeoplePicker.scss';
import { simplAvatarUrl } from '../../api/simplApi';

export class GravatarValue extends React.Component {
  onRemove = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onRemove(this.props.value);
  };

  renderRemoveIcon = () => {
    if (!this.props.onRemove) {
      return null;
    }

    return (
      <span
        className="Select-value-icon"
        aria-hidden="true"
        onMouseDown={this.onRemove}
        onTouchEnd={this.handleTouchEndRemove}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
      >
        ×
      </span>
    );
  };
  render() {
    const props = this.props;

    const avatar = simplAvatarUrl(
      this.props.value.type,
      this.props.value.value,
      32,
      32,
      'crop',
    );

    return (
      <div className="Select-value" title={props.value.title}>
        <span className="Select-value-label">
          <img src={avatar} alt="" className={classes.avatarImgSelect} />
          {props.children}
          {this.renderRemoveIcon()}
        </span>
      </div>
    );
  }
}
GravatarValue.propTypes = {
  onRemove: PropTypes.func,
  value: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.object,
    PropTypes.array,
  ]),
};
export default GravatarValue;



// WEBPACK FOOTER //
// ./src/components/PeoplePicker/GravatarValue.js